// Shopify Recently Viewed Products
console.log('Initializing ShopifyProducts');



const ShopifyProducts = (function() {
    const settings = {
        howManyToShow: 4,
        howManyToStoreInMemory: 4,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        onComplete: null
    };
    let recentlyViewed = [];
    let wrapper = null;
    let template = null;
    let count = 0; // Counts products shown so far
    const cookieSettings = {
        expires: 90,
        path: '/',
        domain: window.location.hostname
    };
    const cookieName = 'shopify_recently_viewed';

    const cookieHandler = {
        write: function(items) {
            console.log('Writing items to cookie:', items);
            setCookie(cookieName, items.join(' '), cookieSettings);
        },
        read: function() {
            const cookie = getCookie(cookieName);
            console.log('Reading items from cookie:', cookie);
            return cookie ? cookie.split(' ') : [];
        },
        destroy: function() {
            console.log('Destroying cookie');
            deleteCookie(cookieName, cookieSettings);
        },
        remove: function(item) {
            const items = this.read();
            const index = items.indexOf(item);
            if (index !== -1) {
                items.splice(index, 1);
                console.log('Removing item from cookie:', item);
                this.write(items);
            }
        }
    };

    function showProducts() {
        console.log('Displaying products');
        wrapper.style.display = 'block';
        if (settings.onComplete) {
            try {
                settings.onComplete();
            } catch (error) {
                console.error(error);
            }
        }
    }

    function loadProducts() {
    console.log('Running loadProducts, count:', count, 'howManyToShow:', settings.howManyToShow);
    if (recentlyViewed.length && count < settings.howManyToShow) {
        fetch(`/products/${recentlyViewed[0]}.js`)
            .then(response => response.json())
            .then(data => {
                console.log('Product fetched:', data.title);  // Log fetched product title
                const productHtml = template.innerHTML.replace(/{{product_title}}/g, data.title);
                wrapper.innerHTML += productHtml;
                recentlyViewed.shift();
                count++;
                loadProducts();  // Call next product load
            })
            .catch(() => {
                console.log('Failed to load product:', recentlyViewed[0]);
                cookieHandler.remove(recentlyViewed[0]);
                recentlyViewed.shift();
                loadProducts();
            });
    } else {
        console.log('Finished loading products, count:', count);
        showProducts();
    }
}


    return {
        resizeImage: function(src, size) {
            if (!size) return src;
            const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (match) {
                const parts = src.split(match[0]);
                return `${parts[0]}_${size}${match[0]}`.replace(/^https?:/, '');
            }
            return null;
        },
        showRecentlyViewed: function(config = {}) {
            console.log('Showing recently viewed with config:', config);
            Object.assign(settings, config);
            recentlyViewed = cookieHandler.read().slice(0, settings.howManyToStoreInMemory); // Limit the stored items
            template = document.getElementById(settings.templateId);
            wrapper = document.getElementById(settings.wrapperId);
            settings.howManyToShow = Math.min(recentlyViewed.length, settings.howManyToShow);
            if (settings.howManyToShow && template && wrapper) {
                count = 0; // Reset count to correctly track shown items
                loadProducts();
            } else {
                console.log('Conditions not met to show recently viewed');
            }
        },
        getConfig: function() {
            return settings;
        },
        clearList: function() {
            cookieHandler.destroy();
        },
        recordRecentlyViewed: function(config = {}) {
            console.log('Recording recently viewed with config:', config);
            Object.assign(settings, config);
            const path = window.location.pathname;
            if (path.indexOf('/products/') !== -1) {
                const productHandle = path.split('/products/')[1];
                let items = cookieHandler.read();
                const index = items.indexOf(productHandle);
                if (index === -1) {
                    items.unshift(productHandle);
                } else {
                    items.splice(index, 1);
                    items.unshift(productHandle);
                }
                items = items.slice(0, settings.howManyToStoreInMemory); // Store only up to the limit
                console.log('Writing recently viewed items:', items);
                cookieHandler.write(items);
            }
        }
    };
})();
